<template>
    <a-modal title="上传地址资料" :confirmLoading="state.loading" centered :bodyStyle="{ padding: '20px' }" :width="1000"
        :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button :loading="state.loading" type="primary">确定</a-button>
            </a-popconfirm>
        </template>
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :rules="rules" :model="formState" v-bind="formLayout" scrollToFirstError="true">
                <a-form-item name="letter_commitment_url" label="名称承诺书">
                    <a-form-item-rest>
                        <Upload :upload_path="state.upload_path" uploadType="picture-card" :limitation="1"
                            :customerName="props.tableColumnsData.full_name" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                            v-model:value="formState.letter_commitment_url" uploadText="上传名称承诺书"
                            :size="formState.main_type == 2 ? 1 : 10">
                        </Upload>
                    </a-form-item-rest>
                </a-form-item>
                <a-form-item name="address_data_urls" label="地址资料">
                    <a-form-item-rest>
                        <Upload :upload_path="state.upload_path" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                            :customerName="props.tableColumnsData.full_name" uploadType="picture-card" :limitation="99"
                            v-model:value="formState.address_data_urls" uploadText="上传地址资料"
                            :size="formState.main_type == 2 || formState.business_type != 1 || formState.is_ws_filiale == 1 ? 1 : 10">
                        </Upload>
                        <!-- <a-button type="primary" @click="createAddressClick(1)">生成</a-button> -->
                    </a-form-item-rest>
                </a-form-item>
                <a-form-item name="other_information_urls" label="其他资料">
                    <a-form-item-rest>
                        <Upload :upload_path="state.upload_path" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                            uploadType="picture-card" :limitation="99" :customerName="props.tableColumnsData.full_name"
                            v-model:value="formState.other_information_urls" uploadText="上传其他资料"
                            :size="formState.main_type == 2 ? 1 : 10">
                        </Upload>
                        <!-- <a-button type="primary" @click="createAddressClick(2)">生成</a-button> -->
                    </a-form-item-rest>
                </a-form-item>

                <a-form-item name="business_license_urls" label="营业执照正副本或遗失声明">
                    <Upload :upload_path="state.upload_path" :accept="['png', 'jpg', 'jpeg', 'pdf']"
                        uploadType="picture-card" :limitation="99" :customerName="props.tableColumnsData.full_name"
                        v-model:value="formState.business_license_urls" uploadText="上传营业执照正副本或遗失声明"
                        :size="formState.main_type == 2 ? 1 : 10">
                    </Upload>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>
<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { LoadingOutlined } from '@ant-design/icons-vue'
import Upload from '@/components/base/Upload.vue'
import { reactive, onMounted, ref, computed, onUnmounted } from 'vue'
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
    }
}
const ruleForm = ref()
const rules = []
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
const state = reactive<any>({
    loading: false,
    upload_path: ''
})
const formState = reactive<any>({
    id: props.tableColumnsData.id,
    main_type: 1,
    letter_commitment_url: '',
    address_data_urls: [],
    other_information_urls: [],
    business_license_urls: []
})
onMounted(() => {
    queryDetail()
})
const queryDetail = () => {
    state.loading = true
    let requestParam = {
        url: `/admin/v1/customer/${props.tableColumnsData.id}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then(async (res) => {
            let data = res.data
            state.upload_path = data.upload_path
            formState.id = data.id
            formState.main_type = data.main_type
            formState.business_license_urls = data.business_license_urls
            formState.letter_commitment_url = data.letter_commitment_url
            formState.address_data_urls = data.address_data_urls
            formState.other_information_urls = data.other_information_urls
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            }
        })
        .finally(() => {
            state.loading = false
        })
}
// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            baseService
                .post('/admin/v1/customerUploadDzzl', formState)
                .then((res: any) => {
                    message.success(res.msg)
                    emit('ok')
                })
                .catch((res) => {
                    message.error(res.msg)
                })
        })
        .catch((err) => {
            console.log('error', err)
        })
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
